// extracted by mini-css-extract-plugin
export default {"collapse":"SizeCodeCollapse_collapse__PQ906"};